import { render, staticRenderFns } from "./ModalMetricsBySkills.vue?vue&type=template&id=2bf47060&scoped=true&"
import script from "./ModalMetricsBySkills.vue?vue&type=script&lang=js&"
export * from "./ModalMetricsBySkills.vue?vue&type=script&lang=js&"
import style0 from "./ModalMetricsBySkills.vue?vue&type=style&index=0&id=2bf47060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf47060",
  null
  
)

export default component.exports